module.exports = {
    // api:'/m-ccd/',
    publicPath:'./'
}


// WEBPACK FOOTER //
// config/prod.js